import { Text } from "@wojo/ui";
import cn from "clsx";
import React from "react";
import { TourExtensionContent } from "../../../generated/graphql";
import styles from "./Itinerary.module.scss";
import { ItineraryDay } from "./ItineraryDay";
import { ItinerarySectionTitle } from "./ItinerarySectionTitle";

type ItineraryExtensionProps = {
    extension?: TourExtensionContent | null;
};

export const ItineraryExtension: React.FC<ItineraryExtensionProps> = ({
    extension,
}) => {
    if (!extension || extension.itineraryItems.length === 0) {
        return null;
    }
    return (
        <>
            {!!extension.name && (
                <Text.Heading
                    order="4"
                    tag="h3"
                    style={{
                        marginBottom: "var(--g-spacing-sm)",
                    }}
                >
                    {extension.name} extension
                </Text.Heading>
            )}
            {!!extension.description && (
                <Text.Body style={{ marginBottom: "var(--g-spacing-xl)" }}>
                    {extension.description}
                </Text.Body>
            )}
            <div
                className={cn(
                    styles["day-by-day"],
                    styles["day-by-day--expanded"],
                )}
            >
                {extension.itineraryItems.map((itineraryElement, index) => {
                    const titleId = `day-extension-title-${index}`;
                    if (
                        itineraryElement.__typename ===
                        "TourItineraryItemContent"
                    ) {
                        const item = itineraryElement;
                        return (
                            <section
                                key={titleId}
                                className={cn(
                                    styles.day,
                                    styles["day--overnight"],
                                )}
                                aria-labelledby={
                                    item.title ? titleId : undefined
                                }
                            >
                                <ItinerarySectionTitle
                                    title={item.title ?? undefined}
                                    isTopLevel
                                    nbNights={item.nbNights}
                                    id={titleId}
                                />
                                {item.days.map(
                                    (overnightDay, overnightIndex) => {
                                        return (
                                            <ItineraryDay
                                                key={overnightIndex}
                                                {...overnightDay}
                                                isTopLevel={!item.title}
                                            />
                                        );
                                    },
                                )}
                            </section>
                        );
                    } else if (
                        itineraryElement.__typename === "TourDayContent"
                    ) {
                        const day = itineraryElement;
                        return (
                            <ItineraryDay
                                {...day}
                                key={titleId}
                                isTopLevel={true}
                            />
                        );
                    }
                })}
            </div>
        </>
    );
};
